function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "4D5458D2-FD67-4D2C-80F0-3FFB907A291F");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "staffNewBulk",
  transform: "translate(-993.000000, -468.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(981.000000, 460.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(12.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Icon-BG",
  fill: "#FFEA8A",
  cx: 14,
  cy: 14,
  r: 14
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Fill",
  fill: "#FFFFFF",
  cx: 10,
  cy: 10,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 M10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 M10,11 C10.553,11 11,10.553 11,10 L11,6 C11,5.447 10.553,5 10,5 C9.447,5 9,5.447 9,6 L9,10 C9,10.553 9.447,11 10,11 M10,12.9004 C9.393,12.9004 8.9,13.3924 8.9,14.0004 C8.9,14.6074 9.393,15.0994 10,15.0994 C10.607,15.0994 11.1,14.6074 11.1,14.0004 C11.1,13.3924 10.607,12.9004 10,12.9004",
  id: "Mask",
  fill: "#8A6116"
}))))));

var SvgFeedbackWarning = function SvgFeedbackWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedbackWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback-warning.50923b49.svg";
export { ForwardRef as ReactComponent };